<template>
  <div>
    <a-row v-if="!isMobile">
      <a-card title="我的设备">
        <div slot="extra">
          <a-button-group>
            <a-button icon="reload" @click="getDeviceList()">刷新</a-button>
            <a-button icon="plus" @click="showBind = true">绑定设备</a-button>
          </a-button-group>
        </div>
        <a-table :columns="columns" :data-source="devices" :scroll="{x: true}" rowKey="device_id">
          <span slot="end_time" slot-scope="text, record">
            <template v-if="record.active_time === ''">
              未激活
            </template>
            <template v-else>
              <span v-if="now < record.end_time">
                <span v-if="record.end_time < 4070880000">
                  {{ record.end_time | timestamp2date }}
                </span>
                <span v-else>
                  <a-tag color="green">永久</a-tag>
                </span>
              </span>
              <span v-else>
                {{ record.end_time | timestamp2date }}
                <p><a-tag color="#f50">已过期</a-tag></p>
              </span>
            </template>
          </span>
          <span slot="status" slot-scope="text, record">
            <a-tag color="green" v-if="record.client.is_connect">在线</a-tag>
            <a-tag v-else>离线</a-tag>
          </span>
          <span slot="info" slot-scope="text, record">
            <span v-if="record.client.is_connect">
              <p>{{ record.client.ip }}</p>
              <p>
                <a-tag>{{ record.client.ipinfo.country }} / {{ record.client.ipinfo.city }}</a-tag>
                <a-tag>{{ record.client.ipinfo.org }}</a-tag>
              </p>
            </span>
            <span v-else>-</span>
          </span>
          <span slot="action" slot-scope="text, record">
            <template v-if="record.active_time !== ''">
              <a-button-group>
                <a-button type="primary" @click="onCharge(record)" icon="dollar" v-if="record.end_time < 4070880000 && isAlipay">充值</a-button>
                <a-button type="info" @click="onRemote(record)" icon="mobile" v-if="record.info.remote_control && isInApp">云控</a-button>
<!--                <a-button type="danger" @click="handleRestart(record)" icon="bug" v-if="now < record.end_time" :disabled="!record.client.is_connect">组网重启</a-button>-->
                <!--              <a-button @click="handleSpeed(record)" icon="dashboard" :disabled="!record.client.is_connect || now > record.end_time">实时状态</a-button>-->
              </a-button-group>
<!--              <a-dropdown :disabled="!record.client.is_connect || now > record.end_time">-->
<!--                <a-menu slot="overlay" style="width: 150px;">-->
<!--                  <a-menu-item @click="handleSpeed(record)"><a-icon type="dashboard"/>实时状态</a-menu-item>-->
<!--                  <a-menu-item @click="handleWifi(record)" :disabled="['armbian', 'r68s'].includes(record.model)"><a-icon type="key"/>设置Wifi密码</a-menu-item>-->
<!--                </a-menu>-->
<!--                <a-button><a-icon type="setting"/>更多操作 <a-icon type="down"/> </a-button>-->
<!--              </a-dropdown>-->
            </template>
          </span>
        </a-table>
      </a-card>
    </a-row>
    <a-row v-else style="overflow-y: scroll;">
      <a-card :title="appType === 'ios' ? '': '我的设备'">
        <a-card :title="record.mac" v-for="record in devices" :key="record.device_id" style="margin-bottom: 10px;">
          <template slot="extra">
            <a-tag color="green" v-if="record.client.is_connect">在线</a-tag>
            <a-tag v-else>离线</a-tag>
          </template>
          <a-descriptions>
            <a-descriptions-item label="有效期">
              <template v-if="record.active_time === ''">
                未激活
              </template>
              <template v-else>
                <span v-if="now < record.end_time">
                  <span v-if="record.end_time < 4070880000">
                    {{ record.end_time | timestamp2date }}
                  </span>
                  <span v-else>
                    <a-tag color="green">永久</a-tag>
                  </span>
                </span>
                <span v-else>
                  {{ record.end_time | timestamp2date }}
                  <span><a-tag color="#f50">已过期</a-tag></span>
                </span>
              </template>
            </a-descriptions-item>
            <a-descriptions-item label="IP信息">
              <span v-if="record.client.is_connect">
                <p>{{ record.client.ip }}</p>
              </span>
              <span v-else>-</span>
            </a-descriptions-item>
            <a-descriptions-item label="网络信息">
              <span v-if="record.client.is_connect">
                <a-tag>{{ record.client.ipinfo.country }} / {{ record.client.ipinfo.city }}</a-tag>
              </span>
              <span v-else>-</span>
            </a-descriptions-item>
            <a-descriptions-item label="操作">
              <template v-if="record.active_time !== ''">
                <a-button-group>
                  <a-button size="small" type="primary" @click="onCharge(record)" icon="dollar" v-if="record.end_time < 4070880000">充值</a-button>
                  <a-button size="small" type="info" @click="onRemote(record)" icon="mobile" v-if="record.info.remote_control && isInApp">云控</a-button>
<!--                  <a-button size="small" type="danger" @click="handleRestart(record)" icon="bug" :disabled="!record.client.is_connect || now > record.end_time">组网重启</a-button>-->
                  <!--                <a-button size="small" @click="handleSpeed(record)" icon="dashboard" :disabled="!record.client.is_connect || now > record.end_time">实时状态</a-button>-->
                </a-button-group>
<!--                <a-dropdown :disabled="!record.client.is_connect || now > record.end_time">-->
<!--                  <a-menu slot="overlay" style="width: 150px;">-->
<!--                    <a-menu-item @click="handleSpeed(record)"><a-icon type="dashboard" />实时状态</a-menu-item>-->
<!--                    <a-menu-item @click="handleWifi(record)" :disabled="['armbian', 'r68s'].includes(record.model)"><a-icon type="key" />设置Wifi密码</a-menu-item>-->
<!--                  </a-menu>-->
<!--                  <a-button size="small"><a-icon type="setting" />更多操作 <a-icon type="down" /> </a-button>-->
<!--                </a-dropdown>-->
              </template>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>
        <a-empty description="无关联设备" v-if="devices.length === 0 && !isLoading"></a-empty>
        <div style="display: flex; justify-content: center;" v-if="isLoading">
          <a-spin size="large"/>
        </div>
      </a-card>
    </a-row>
    <a-card title="实时流量" v-if="showSpeed">
      <ve-line
        style="margin-left: -20px;"
        :width="'95vw'"
        :height="'50vh'"
        :data="speedData"
        :settings="chartSetting"
        ref="chart"
      ></ve-line>
    </a-card>
    <div v-html="payContent"></div>
    <a-modal title="充值" v-model="showCharge" width="800px" :cancel-text="'取消'" :ok-text="'开始充值'" @ok="onPreCharge" :confirm-loading="isLoading">
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
        <a-form-item label="设备">
          {{ device.mac }}
        </a-form-item>
        <a-form-item label="充值计划">
          <a-radio-group v-model="charge.service.service_id" @change="onServiceChange">
            <a-radio-button v-for="service in services" :key="service.service_id" :value="service.service_id" v-if="service.price > 0" :disabled="service.service_id === '99yr'">
              {{ service.name }}
              <span v-if="service.service_id === '99yr'">请联系客服</span>
              <a-tag color="#f50" v-if="service.tag">
                <i class="fa fa-ticket"></i>
                {{ service.tag }}
              </a-tag>
              <span color="#108ee9" v-if="service.service_id === '99yr'">
                <i class="fa fa-diamond" style="color: #108ee9"/>
              </span>
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="充值后至" v-if="charge.service.service_id !== ''">
          <span v-if="charge.service.time > 0">{{ charge.end_time | timestamp2date }}</span>
          <span v-else>永久</span>
        </a-form-item>
        <a-form-item label="充值金额">
          <span v-if="charge.service.price > 1">￥{{ charge.service.price | number('0,0') }}元</span>
          <span v-else-if="charge.service.price > 0">￥{{ charge.service.price | number('0,0.00') }}元</span>
          <span v-else>请选择</span>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal title="服务重启" v-model="showRestart" :cancel-text="'取消'" :ok-text="'确认重启'" @ok="onRestart" :confirm-loading="isLoading">
      <p>是否确认重启 <b style="font-size: 20px;">{{ device.mac }}</b> 网络加速服务？</p>
      <span style="display: flex; justify-content: center; margin-top: 30px;">
        <a-spin size="large" :spinning="isLoading"/>
      </span>
    </a-modal>

    <a-modal title="设备绑定" v-model="showBind" width="400px" :cancel-text="'取消'" :ok-text="'绑定'" @ok="bindDevice" :confirm-loading="isLoading">
      <a-form>
        <a-form-item label="设备mac">
          <a-input v-model="bind.mac" placeholder="xx-xx-xx-xx-xx-xx" maxLength="17"></a-input>
          <span style="font-size: 14px;">例：xx-xx-xx-xx-xx-xx，不区分大小写</span>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal title="支付提示" v-model="showPayNotice" :cancel-text="'取消'" :ok-text="'已完成支付'" @ok="refresh">
      <h6>是否完成支付？</h6>
    </a-modal>

    <a-modal title="Wifi密码设置" v-model="showWifi" :cancel-text="'取消'" :ok-text="'修改'" @ok="setWifi" :confirm-loading="isLoading">
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
        <a-form-item label="Wifi密码">
          <a-input-password v-model="wifiConfig.password" style="width: 200px;" :max-length="12"></a-input-password>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { getToken, getAppType } from '@/libs/util'
import { Device } from '@/api/model'
import { getPlans } from '@/api/product'
import { getDevices, addDeviceOrder, sendDeviceCommand, bindDevice, setDeviceWifi } from '@/api/device'
import { baseMixin } from '@/libs/app-mixin'
import { Base64 } from 'js-base64'
var md5 = require('js-md5')
var mobile = require('is-mobile')
import VeLine from 'v-charts/lib/line.common'

export default {
  name: 'DeviceList',
  mixins: [baseMixin],
  components: {
    VeLine
  },
  props: {
    isAlipay: {
      type: Boolean,
      default: true
    },
    isInApp: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isMobile: mobile(),
      showCharge: false,
      showRestart: false,
      showBind: false,
      showPayNotice: false,
      showSpeed: false,
      showWifi: false,
      isLoading: false,
      appType: getAppType(),
      columns: [
        {
          title: '设备mac',
          width: 180,
          dataIndex: 'mac',
          key: 'mac'
        },
        {
          title: '有效期',
          width: 180,
          scopedSlots: { customRender: 'end_time' }
        },
        {
          title: '状态',
          width: 100,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '终端信息',
          width: 300,
          scopedSlots: { customRender: 'info' }
        },
        {
          title: '操作',
          width: 230,
          scopedSlots: { customRender: 'action' }
        }
      ],
      devices: [],
      device: Device(),
      charge: {
        service: {
          service_id: '',
          name: '',
          end_time: 0
        },
        end_time: ''
      },
      services: [],
      payContent: '',
      now: '',
      bind: {
        mac: ''
      },
      speedData: {
        columns: ['时间', '上传', '下载'],
        rows: []
      },
      chartSetting: {
        area: true,
        xAxisType: 'time',
        yAxisType: ['0.[00]a', '0.[00]a']
      },
      wsClient: null,
      wsRetry: 0,
      wifiConfig: {
        device: {},
        password: ''
      }
    }
  },
  methods: {
    getDeviceList () {
      this.isLoading = true
      getDevices({}).then(res => {
        this.isLoading = false
        if (typeof res.result.list !== 'undefined') {
          this.devices = res.result.list
        } else {
          this.getDeviceList()
        }
      })
    },
    getPlans () {
      getPlans('charge').then(res => {
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        this.services = res.result.services
      })
    },
    onCharge (device) {
      if (!device.client.is_connect) {
        this.$message.info('请确认设备是否正确联网')
        return false
      }
      this.device = device
      if (this.now < this.device.end_time) {
        this.charge.end_time = this.device.end_time
      } else {
        this.charge.end_time = this.now
      }
      this.showCharge = true
    },
    onRemote (device) {
      if (!device.client.is_connect) {
        this.$message.info('请确认设备是否正确联网')
        return false
      }
      window.location.href = device.info.remote_control
    },
    handleRestart (device) {
      if (!device.client.is_connect) {
        this.$message.info('请确认设备是否正确联网')
        return false
      }
      this.device = device
      this.showRestart = true
    },
    handleSpeed (device) {
      this.showSpeed = true
      this.initWs(device)
      // setInterval(() => {
      //   if (this.speedData.rows.length < 60) {
      //     this.speedData.rows.push({'时间': Date.parse(new Date()) / 1000, '上传': Math.random() * 10000, '下载': Math.random() * 10000})
      //   } else {
      //     this.speedData.rows.splice(0, 1)
      //     this.speedData.rows.push({'时间': Date.parse(new Date()) / 1000, '上传': Math.random() * 10000, '下载': Math.random() * 10000})
      //   }
      // }, 1000)
    },
    handleWifi (device) {
      if (device.model === 'xr10') {
        this.showWifi = true
        this.wifiConfig.device = device
      } else {
        this.$message.info('该型号暂不支持此功能')
      }
    },
    onRestart () {
      if (this.isLoading) {
        this.$message.info('正在执行中，请稍后...')
        return false
      }
      this.isLoading = true
      sendDeviceCommand({
        device_id: this.device.device_id,
        command: 'restart_service'
      }).then(res => {
        this.showRestart = false
        this.isLoading = false
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        this.$message.success('执行完成')
      })
    },
    onServiceChange (e) {
      let time = 0
      this.services.forEach(v => {
        if (v.service_id === e.target.value) {
          time = v.time
          this.charge.service.price = v.price
          this.charge.service.time = v.time
          this.charge.service.name = v.name
          this.charge.service.tag = v.tag
          this.charge.service.tags = v.tags
          this.charge.service.sign = v.sign
        }
      })
      if (time > 0) {
        if (this.now < this.device.end_time) {
          this.charge.end_time = this.device.end_time + time
        } else {
          this.charge.end_time = this.now + time
        }
      } else {
        this.charge.end_time = 4102415999
      }
    },
    onPreCharge (e) {
      console.log(e)
      if (this.isLoading) {
        this.$message.info('正在创建订单，请稍后')
        return false
      }
      if (this.charge.service.service_id === '') {
        this.$message.info('请选择充值计划')
        return false
      }
      this.addDeviceOrder()
    },
    addDeviceOrder () {
      this.isLoading = true
      addDeviceOrder({
        device_id: this.device.device_id,
        mac: this.device.mac,
        charge: this.charge,
        is_mobile: mobile()
      }).then(res => {
        this.showCharge = false
        this.isLoading = false
        console.log(res)
        this.payContent = res.result.content
        if (this.isInApp) {
          let redirect_uri = location.protocol + '//' + location.host + '/#/in-app/trade/pay?trade_id=' + res.result.trade_id
          let token = getToken()
          let nonce = Math.round(new Date().getTime() / 1000)
          let sign = md5(Base64.encode(token) + nonce + 'zerofast')
          let url = location.protocol + '//' + location.host + '/#/in-app/sso?token=' + token +
            '&nonce=' + nonce + '&sign=' + sign + '&url=' + Base64.encode(redirect_uri)
          if (getAppType() === 'ios') {
            setTimeout(() => {
              this.showPayNotice = true
            }, 1000 * 5)
            window.webkit.messageHandlers.safari.postMessage(url)
          } else if (getAppType() === 'android') {
            window.App.openBrowser(url)
          }
        } else {
          setTimeout(() => {
            document.forms['alipay_submit'].submit()
          }, 500)
        }
      })
    },
    bindDevice () {
      if (this.bind.mac.length !== 17) {
        this.$message.info('mac地址输入不完整')
        return false
      }
      const par = /^[0-9a-f]{1,2}([\.:-])(?:[0-9a-f]{1,2}\1){4}[0-9a-f]{1,2}$/i
      const n = this.bind.mac.search(par)
      if (n === -1) {
        this.$message.info('mac地址输入不正确')
        return false
      }
      bindDevice({
        mac: this.bind.mac
      }).then(res => {
        this.showBind = false
        console.log(res)
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        this.bind.mac = ''
        this.$message.success('绑定成功')
        this.getDeviceList()
      })
    },
    timerCounter () {
      let i = 0
      for (i = 0; i < 10; i++) {
        clearInterval(i)
      }
      setInterval(() => {
        this.now = Date.parse(new Date()) / 1000
      }, 1000 * 5)
    },
    refresh () {
      location.reload()
    },
    initWs (device) {
      if (this.wsRetry > 5) {
        return false
      }
      if (this.wsClient) {
        this.wsClient.close()
      }
      this.wsClient = new WebSocket('wss://www.ai-ifast.com/mars/traffic?deviceId=' + device.device_id)
      this.wsClient.onopen = (e) => {
        this.wsClient.send('hello')
      }
      this.wsClient.onmessage = (e) => {
        let data = JSON.parse(e.data)
        if (this.speedData.rows.length < 60) {
          this.speedData.rows.push({'时间': Date.parse(new Date()), '上传': data.up, '下载': data.down})
        } else {
          this.speedData.rows.splice(0, 1)
          this.speedData.rows.push({'时间': Date.parse(new Date()), '上传': data.up, '下载': data.down})
        }
      }
      this.wsClient.onclose = (e) => {}
      this.wsClient.onerror = (err) => {
        this.wsRetry++
      }
    },
    setWifi () {
      if (this.wifiConfig.password.length < 8) {
        this.$message.info('密码需大于8位')
        return false
      }
      this.isLoading = true
      setDeviceWifi({
        device_id: this.wifiConfig.device.device_id,
        password: this.wifiConfig.password
      }).then(res => {
        this.isLoading = false
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        this.wifiConfig = {
          device: {},
          password: ''
        }
        this.$message.success('设置完成，Wifi即将重启')
        this.showWifi = false
      })
    },
    getIpAddress () {
      window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
      if (window.RTCPeerConnection) { // 检查浏览器支持
        var pc = new RTCPeerConnection({iceServers: [
            { urls: "stun:stun.l.google.com:19302" },
            { urls: "stun:stun2.l.google.com:19302" },
            { urls: "stun:stun4.l.google.com:19302" }
          ]}) // 创建RTCPeerConnection对象
        pc.createDataChannel("") // 创建一个数据通道

        pc.onicecandidate = function(event) {
          if (event.candidate) {
            var ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-fA-F0-9]{1,4}(:[a-fA-F0-9]{1,4}){7})/g
            if (event.candidate.candidate.match(ipRegex) !== null) {
              var ipAddr = event.candidate.candidate.match(ipRegex)[0] || '' // 从candidate中提取IP地址
              console.log('内网IP地址:', ipAddr)
              pc.onicecandidate = null
            }
          }
        };

        pc.createOffer().then(function(sdp) {
          pc.setLocalDescription(sdp)
        }).catch(function(reason) {
          console.error('获取内网IP失败:', reason)
        })
      } else {
        console.log("您的浏览器不支持RTCPeerConnection.")
      }
    },
    checkInNet() {
      fetch('http://192.168.15.147:9900/version.txt')
        .then(response => {
          if (response.ok) { // 如果响应状态码是200-299
            console.log('成功获取到文件');
          } else {
            console.log('无法获取文件，响应状态码为：', response.status);
          }
        })
        .catch(error => {
          console.log('请求过程中发生错误：', error);
        });
    },
    change () {
      this.now = Date.parse(new Date()) / 1000
      this.timerCounter()
      this.getPlans()
      this.getDeviceList()
      this.checkInNet()
    }
  },
  mounted () {
    this.change()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/DeviceList.vue